@if (articleShareContent) {
  <div class="row justify-content-center">
    <div class="col-12 col-lg-10 col-xl-8 mt-3 mb-4">
      <span class="share-title" i18n="@@contentful.share">Share</span>
      @if (hasFacebook) {
        <span
          aria-label="Facebook"
          class="icons"
          role="button"
          tabindex="0"
          (click)="openModal('facebook')"
          (keyup)="openModal('facebook')"
        >
          <i class="fab fa-facebook-f"></i>
        </span>
      }

      @if (hasTwitter) {
        <span
          aria-label="Twitter"
          class="icons"
          role="button"
          tabindex="0"
          (click)="openModal('twitter')"
          (keyup)="openModal('twitter')"
        >
          <i class="fab fa-twitter"></i>
        </span>
      }
    </div>
  </div>
  <ui-modal sourceId="sharedArticleModal" [title]="articleShareContent.fields.title">
    <div class="modal-container">
      <p>{{ articleShareContent.fields.body }}</p>
      @if (facebookClicked) {
        <button class="btn btn-primary" i18n="@@contentful.shareOnFacebook" type="button" (click)="share()">
          Share on Facebook
        </button>
      }
      @if (twitterClicked) {
        <button class="btn btn-primary" i18n="@@contentful.shareOnTwitter" type="button" (click)="share()">
          Share on Twitter
        </button>
      }
    </div>
  </ui-modal>
}
